module.exports = __webpack_public_path__ + "static/media/amitabh.02cfc587.jpg";